"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconSet = void 0;
const react_1 = require("@chakra-ui/react");
const sunshine_icons_1 = require("@shinetools/sunshine-icons");
const react_2 = __importDefault(require("react"));
/**
 * build the icons set from the icons schema provided by sunshine-icons
 */
exports.iconSet = Object.entries(sunshine_icons_1.icons).reduce((iconsMap, [iconName, elements]) => {
    const childrens = elements.map((path, i) => (react_2.default.createElement(path.component, { key: `iconName-${path.component}-${i}`, ...path.props })));
    return iconsMap.set(iconName, (0, react_1.createIcon)({ path: childrens, viewBox: sunshine_icons_1.viewBox }));
}, new Map());
const SunshineIcon = (0, react_1.forwardRef)(({ name, size = '1em', ...props }, ref) => {
    const { 
    // use theme sizes or fallback to the size prop
    width = size, height = size, ...styles } = (0, react_1.useStyleConfig)('SunshineIcon', { size });
    return (react_2.default.createElement(react_1.chakra.svg, { __css: { height, width, ...styles }, as: exports.iconSet.get(name), ref: ref, ...props }));
});
exports.default = SunshineIcon;
